import React from "react"
import styled from "styled-components"
import { Spring } from "react-spring/renderprops"

export const APP_WIDTH = 960
// export const springConfig = { tension: 200, friction: 15 };
export const springConfig = { tension: 42, friction: 12, duration: 1000 }
export const Spring2 = ({ step = 1, ...props }) => (
  <Spring config={springConfig} delay={100 + step * 300} {...props} />
)

export const Colors = {
  background: "#f8f8fa",
  text: "rgba(0, 0, 0, .7)",
  sea: `rgb(69, 129, 184)`,
  green: `rgb(20, 228, 218)`,
  blue: `rgb(84, 68, 174)`,
  purple: `rgb(167, 74, 200)`,
  orange: `rgb(252, 103, 25)`,
  yellow: `rgb(252, 206, 1)`,
}

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ center }) => (center ? "center" : "flex-start")};
  padding: 0 15px;
  height: 60px;
  width: 100%;
  max-width: ${APP_WIDTH}px;
  margin: auto;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
`
export const Logo = styled.div`
  display: inline;
  position: relative;
  font-size: 24px;
  font-weight: bold;
  color: ${Colors.orange};
  text-transform: uppercase;
  transition: transform 200ms ease;
  margin: 0 -2px;
`
export const Button = styled.button.attrs({
  type: "button",
})`
  backface-visibility: hidden;
  padding: 0 20px;
  min-height: ${({ height = 50 }) => height}px;
  display: flex;
  align-items: center;
  border-radius: 3px;
  border: transparent solid thin;
  background-color: ${({ color = Colors.orange }) => color};
  color: rgba(255, 255, 255, 0.8);
  font-size: inherit;
  font-weight: bold;
  overflow: hidden;
  position: relative;
  user-select: none;
  transition: transform 200ms ease, width 200ms ease,
    background-color 200ms ease;
  &::before {
    content: "";
    background-color: transparent;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transition: background-color 200ms ease;
  }
  &:hover {
    transform: translateY(${({ hover = true }) => hover && -1}px);
    &::before {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
  &:active {
    transform: translateY(0px);
    &::before {
      background-color: rgba(255, 255, 255, 0);
    }
  }
  ${({ disabled }) =>
    disabled &&
    `
      cursor: default;
      pointer-events: none;
      background-color: rgba(245, 245, 245, 1) !important;
      color: rgba(0, 0, 0, .1) !important;
  `};
`
